import React, { FC } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import PartnerHubPage from './PartnerHubPage/PartnerHubPage';

const PartnerFeature: FC = () => (
  <Switch>
    <Route path="/maps/safety-information" exact>
      <Redirect to="/maps/prepare" />
    </Route>
    <Route
      path="/maps/safety-information/:url"
      render={({ match }) => (
        <Redirect to={`/maps/partner/${match.params.url}`} />
      )}
    />
    <Route path="/maps/partner/:slug">
      <PartnerHubPage />
    </Route>
  </Switch>
);

export default PartnerFeature;
